import React, { Fragment } from 'react';
import InfiniteScrollTable from "../../infinite-scroll-table";
import { Icon, Input, Modal, Select} from "antd";
import {translate} from "react-i18next";
import { compose } from 'redux';
import { EL_COL_TYPE_DIMENSION, EL_DIMENSION_ROLE_FREQUENCY, EL_DIMENSION_ROLE_GENERIC, EL_DIMENSION_ROLE_TERRITORY, EL_DIMENSION_ROLE_TIME, getELDimensionRoleTranslations } from '../constants';
import { MARGIN_MD, MARGIN_SM } from '../../../styles/constants';
import { getIconType } from './utils';
import Selector from '../../selector';
import { getArtefactTripletFromString, getStringFromArtefactTriplet } from '../../../utils/sdmxJson';

const TABLE_COL_WIDTH = 300;
const TABLE_SELECT_WIDTH = 200;

const ELDimensionsStepTable = ({
                                t,
                                structureColumns,
                                setRowToAssociateCodelist,
                                astTerritorialCodelist,
                                onChange,    
                              }) => {

  const dimensions = (structureColumns || []).filter(column => column.type === EL_COL_TYPE_DIMENSION);
  
  const columns = [      
    {
      title: t('components.easyLoading.dimensions.table.id.title'),
      dataIndex: "id"
    },
    {
      title: t('components.easyLoading.dimensions.table.role.title'),
      dataIndex: "role",
      width: TABLE_COL_WIDTH,
      noFilter: true,
      noSort: true,
      render: (role, row) => {
        return (
            <Select
              style={{marginRight: MARGIN_MD, width: TABLE_SELECT_WIDTH}}
              value={row.dimensionDefinition.role}
              onChange={(value) => {
                if (value === EL_DIMENSION_ROLE_GENERIC) {
                  onChange(row.id, value, row.dimensionDefinition.association)
                } else {
                  if (structureColumns.some(c => c.dimensionDefinition.role === value)) {
                    const roleTranslation = getELDimensionRoleTranslations(t)[value]
                    Modal.error({
                      title: t('components.easyLoading.dimensions.table.alerts.dimensionRole.title'),
                      content: t('components.easyLoading.dimensions.table.alerts.dimensionRole.onlyOne', {type: roleTranslation})
                    });
                  } else if (value === EL_DIMENSION_ROLE_TIME) {
                    if ((row.translations || []).length > 0) {
                      Modal.error({
                        title: t('components.easyLoading.dimensions.table.alerts.dimensionRole.title'),
                        content: t('components.easyLoading.dimensions.table.alerts.dimensionRole.nonTranslated')
                      });
                    } else {                      
                      onChange(row.id, value, row.dimensionDefinition.association);                      
                    }
                  }
                  else if (value === EL_DIMENSION_ROLE_TERRITORY) {
                    let dimAssociation = row.dimensionDefinition.association;
                    if (astTerritorialCodelist) {
                      dimAssociation = getArtefactTripletFromString(astTerritorialCodelist);
                    }                                        
                    onChange(row.id, value, dimAssociation); 
                  }
                  else {
                    onChange(row.id, value, row.dimensionDefinition.association)
                  }
                }             
              }}
            >
              {[
                EL_DIMENSION_ROLE_GENERIC,
                EL_DIMENSION_ROLE_FREQUENCY,
                EL_DIMENSION_ROLE_TIME,
                EL_DIMENSION_ROLE_TERRITORY
              ].map(opt =>
                <Select.Option
                  key={opt}
                  value={opt}
                  title={getELDimensionRoleTranslations(t)[opt]}
                >
                  <Icon type={getIconType(opt)} style={{marginRight: MARGIN_SM}}/>
                  {getELDimensionRoleTranslations(t)[opt]}
                </Select.Option>
              )}
            </Select>
        )
      }
    },
    {
      title: t('components.easyLoading.dimensions.table.association.title'),
      dataIndex: "association",
      width: TABLE_COL_WIDTH,
      noFilter: true,
      noSort: true,
      render: (association, row) => {
          if ((row.translations || []).length > 0) {
            const text = [];
            row.translations.forEach(t => {
              text.push(`${t.column} (${t.lang.toUpperCase()})`);
            })
            return <span>{`${t('components.easyLoading.dimensions.table.association.translation')} ${text.join(' , ')}`}</span>
          }         
          else if (row.dimensionDefinition.role !== EL_DIMENSION_ROLE_TIME) {
            if (row.dimensionDefinition.role === EL_DIMENSION_ROLE_TERRITORY && astTerritorialCodelist) {
              return (
                <Input disabled 
                  style={{backgroundColor: "inherit"}}
                  value={getStringFromArtefactTriplet(row.dimensionDefinition.association)}/>
              );  
            } else {
              return (
                <Selector
                  selectTitle={t('components.easyLoading.dimensions.table.association.selector.selectTitle')}
                  resetTitle={t('components.easyLoading.dimensions.table.association.selector.resetTitle')}
                  onSelect={() => setRowToAssociateCodelist(row)}
                  onReset={() => onChange(row.id, row.dimensionDefinition.role, null)}
                  value={association}
                  render={codelist => codelist
                    ? getStringFromArtefactTriplet(codelist)
                    : ""}
                />
              ) 
            }                      
          }
          else {
            return null
          }
          
        }                
    }   
  ];
  
  return ( 
    <Fragment>            
      <InfiniteScrollTable
        data={dimensions.map(dim => ({
          ...dim,
          role: dim.dimensionDefinition.role,
          association: dim.dimensionDefinition.association
        }))}
        getRowKey={row => row.id}
        columns={columns}
      />
      
    </Fragment>
  )
};

export default compose(
  translate()
)(ELDimensionsStepTable);


// WEBPACK FOOTER //
// ./src/components/easy-loading/dimensions-step/Table.jsx